/* eslint-disable @typescript-eslint/no-explicit-any */
import { SearchResultContainerStyles } from './SearchResultStyles'

interface SearchResultLayoutProps {
  filterCopy: any
  searchTerm: string
  totalItems: number
}

const SearchResultLayout = ({
  filterCopy,
  searchTerm,
  totalItems,
}: SearchResultLayoutProps) => {
  return (
    <SearchResultContainerStyles>
      <p className="label">
        {`${filterCopy?.resultsFor} `}
        <span>{`"${searchTerm}"`}</span>
      </p>
      <span className="quantity-items">{`(${totalItems})`}</span>
    </SearchResultContainerStyles>
  )
}

export default SearchResultLayout
